<template>
  <v-dialog
    v-model="show"
    :close-on-content-click="false"
    transition="scale-transition"
    max-width="300px"
  >
    <v-date-picker
      v-model="date"
      @input="selectDate"
      first-day-of-week = 1
      locale="ru"
      color="#4169E1"
      full-width
      :max="maxDate"
      :min="minDate"
    ></v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    passedDate: String,
    maxDate: String,
    minDate: String
  },
  data: () => ({
    date: ''
  }),
  created () {
    this.date = this.passedDate
  },
  methods: {
    selectDate: function () {
      this.$emit('update-date', this.date)
      this.show = false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
